var render = function render(_c,_vm){return _c('section',{staticClass:"FormSect"},[(_vm.props.title)?_c('div',{staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.props.title))]),(_vm.props.sub)?_c('div',{staticClass:"sub"},[_vm._v(" "+_vm._s(_vm.props.sub)+" ")]):_vm._e()]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }